export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7313.f12507cf.jpg";